// デジタルサイネージ種別に対応するページ
define({
    '1': 'signage/disasterPreventionStatusSignage',
    '2': 'signage/shelterOverviewSignage',
    '3': 'signage/shelterListSignage',
    '4': 'signage/evacOrderOverviewSignage',
    '5': 'signage/evacOrderHistorySignage',
    '6': 'signage/damageOverviewSignage',
    '7': 'signage/damageListSignage',
    '8': 'signage/disasterPreventionOverview',
    '9': 'signage/chronologyOverviewSignage',
    '10': 'signage/chronologyListSignage',
    '11': 'signage/weatherInfoStatusSignage',
    '12': 'signage/observationOverviewSignage',
    '13': 'signage/earthquakeStatusSignage',
    '14': 'signage/lifelineOverviewSignage',
    '15': 'signage/mapSignage',
    '16': 'signage/thematicEvacuationSignage'
});
